export const LOADER_SHOW = Symbol('LOADER_SHOW');
export const BTN_LOADER_SHOW = Symbol('BTN_LOADER_SHOW');
export const LOADER_HIDE = Symbol('LOADER_HIDE');
export const BTN_LOADER_HIDE = Symbol('BTN_LOADER_HIDE');

export function showLoader(overlay = true) {
    if (!overlay) {
        return {
            type:       BTN_LOADER_SHOW
        }
    }
    return {
        type:       LOADER_SHOW
    }
}

export function hideLoader(overlay = true) {
    if (!overlay) {
        return {
            type:       BTN_LOADER_HIDE
        }
    }
    return {
        type:       LOADER_HIDE
    }
}